var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 6.5625L16.625 3.5M18.375 1.75L16.625 3.5L18.375 1.75ZM9.96625 10.1587C10.418 10.6045 10.7772 11.1353 11.023 11.7204C11.2689 12.3056 11.3965 12.9336 11.3986 13.5683C11.4008 14.203 11.2773 14.8318 11.0354 15.4186C10.7935 16.0054 10.4379 16.5386 9.98912 16.9874C9.54032 17.4362 9.00718 17.7918 8.42039 18.0337C7.83359 18.2756 7.20475 18.399 6.57005 18.3969C5.93535 18.3948 5.30735 18.2671 4.72219 18.0213C4.13703 17.7755 3.60628 17.4163 3.1605 16.9645C2.28386 16.0569 1.79879 14.8412 1.80975 13.5794C1.82072 12.3176 2.32684 11.1105 3.21912 10.2182C4.1114 9.32597 5.31843 8.81985 6.58025 8.80888C7.84207 8.79792 9.05772 9.28299 9.96537 10.1596L9.96625 10.1587ZM9.96625 10.1587L13.5625 6.5625L9.96625 10.1587ZM13.5625 6.5625L16.1875 9.1875L19.25 6.125L16.625 3.5L13.5625 6.5625Z",
    stroke: "#635DDE",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.07fb9e7280c612335d1b1029bbe26fed.svg";
export { ForwardRef as ReactComponent };